import type { CollectionsData, PaymentLinkRow } from './types';

/** Waiting rows first (§4.3), then newest-first by Sent. 3 + 6 + 2 + 1 = 12. */
const ROWS: PaymentLinkRow[] = [
  // ── Waiting (3) — the only rows anybody can act on, so they sort first ──
  {
    id: 'l1', patient: 'Renata Oyelaran', patientId: 'p-3182', label: 'Cleaning balance',
    amount: 680, channel: 'text', destination: '(415) 555‑0148', destinationKind: 'phone',
    sentRelative: '2 hours ago', sentAbsolute: 'Sep 24, 3:39 pm', status: 'waiting',
    outcomeLead: 'Opened, not paid', outcomeSub: 'Expires 4:10 pm today. Opened twice on a phone.',
    payUrl: 'https://elva.to/p/7Kq2', canPayNow: true,
  },
  {
    id: 'l2', patient: 'Marcus Feld', patientId: 'p-2044',
    amount: 320, channel: 'email', destination: 'm.feld@gmail.com', destinationKind: 'email',
    sentRelative: 'Yesterday, 5:12 pm', sentAbsolute: 'Sep 23, 5:12 pm', status: 'waiting',
    outcomeLead: 'Delivered', outcomeSub: 'Expires 9:20 am tomorrow.',
    payUrl: 'https://elva.to/p/3Btx', canPayNow: true,
  },
  {
    id: 'l3', patient: 'Priya Anand', patientId: 'p-5510', label: 'Copay',
    amount: 240, channel: 'text', destination: '(210) 555‑0172', destinationKind: 'phone',
    sentRelative: 'Yesterday, 1:04 pm', sentAbsolute: 'Sep 23, 1:04 pm', status: 'waiting',
    outcomeLead: 'Delivered, not opened', outcomeSub: 'Expires 5:12 pm tomorrow.',
    payUrl: 'https://elva.to/p/9Wmz', canPayNow: true,
  },
  // ── Paid (6) ──
  {
    id: 'l4', patient: 'Grace Winslow', patientId: 'p-1290', label: 'Crown balance',
    amount: 1850, channel: 'text', destination: '(415) 555‑2231', destinationKind: 'phone',
    sentRelative: 'Yesterday, 3:39 pm', sentAbsolute: 'Sep 23, 3:39 pm', status: 'paid',
    outcomeLead: 'Paid Sep 23, 4:02 pm', outcomeSub: 'Card · 23 minutes after sending.',
  },
  {
    id: 'l5', patient: 'Theo Marchetti', patientId: 'p-4471',
    amount: 96, channel: 'email', destination: 't.marchetti@outlook.com', destinationKind: 'email',
    sentRelative: 'Sep 22, 11:20 am', sentAbsolute: 'Sep 22, 11:20 am', status: 'paid',
    outcomeLead: 'Paid Sep 22, 2:47 pm', outcomeSub: 'Card · same day.',
  },
  {
    id: 'l6', patient: 'Sandra Beaulieu', patientId: 'p-3355', label: 'Balance after insurance',
    amount: 184, channel: 'qr', destination: 'Shown at the front desk', destinationKind: 'desk',
    sentRelative: 'Sep 21, 9:02 am', sentAbsolute: 'Sep 21, 9:02 am', status: 'paid',
    outcomeLead: 'Paid Sep 21, 9:05 am', outcomeSub: 'At the desk · card on the terminal.',
  },
  {
    id: 'l7', patient: 'Devin Okafor', patientId: 'p-6620',
    amount: 512, channel: 'text', destination: '(408) 555‑0119', destinationKind: 'phone',
    sentRelative: 'Sep 20, 4:44 pm', sentAbsolute: 'Sep 20, 4:44 pm', status: 'paid',
    outcomeLead: 'Paid Sep 20, 6:10 pm', outcomeSub: 'Card · 1 hour 26 minutes after sending.',
  },
  {
    id: 'l8', patient: 'Lena Hoffmann', patientId: 'p-7781', label: 'Whitening',
    amount: 275, channel: 'email', destination: 'lena.h@icloud.com', destinationKind: 'email',
    sentRelative: 'Sep 18, 10:15 am', sentAbsolute: 'Sep 18, 10:15 am', status: 'paid',
    outcomeLead: 'Paid Sep 19, 8:31 am', outcomeSub: 'Card · next morning.',
  },
  {
    id: 'l9', patient: 'Arturo Salas', patientId: 'p-8123',
    amount: 143, channel: 'qr', destination: 'Shown at the front desk', destinationKind: 'desk',
    sentRelative: 'Sep 16, 2:20 pm', sentAbsolute: 'Sep 16, 2:20 pm', status: 'paid',
    outcomeLead: 'Paid Sep 16, 2:22 pm', outcomeSub: 'At the desk · card on the terminal.',
  },
  // ── Expired (2) — amber, the ones to look at (§5) ──
  {
    id: 'l10', patient: 'Harold Pinkett', patientId: 'p-9040', label: 'Bridge balance',
    amount: 940, channel: 'email', destination: 'hpinkett@aol.com', destinationKind: 'email',
    sentRelative: 'Sep 17, 9:00 am', sentAbsolute: 'Sep 17, 9:00 am', status: 'expired',
    outcomeLead: 'Never opened', outcomeExpiry: 'expired Sep 18',
    outcomeSub: 'Email may be wrong — the last two also went unopened. Try a text.',
  },
  {
    id: 'l11', patient: 'Bianca Sol', patientId: 'p-2277',
    amount: 410, channel: 'text', destination: '(650) 555‑0188', destinationKind: 'phone',
    sentRelative: 'Sep 15, 4:12 pm', sentAbsolute: 'Sep 15, 4:12 pm', status: 'expired',
    outcomeLead: 'Opened twice, not paid', outcomeExpiry: 'expired Sep 17',
    outcomeSub: 'Worth a call before sending another link.',
  },
  // ── Canceled (1) — grey, nothing is wrong (§5) ──
  {
    id: 'l12', patient: 'Owen Delacroix', patientId: 'p-3901', label: 'Onlay #3',
    amount: 1240, channel: 'text', destination: '(512) 555‑0143', destinationKind: 'phone',
    sentRelative: 'Sep 19, 11:48 am', sentAbsolute: 'Sep 19, 11:48 am', status: 'canceled',
    outcomeLead: 'Cancelled by Dana, 20 minutes in',
    outcomeSub: 'Insurance had not been billed yet. The patient never paid it.',
  },
];

export const COLLECTIONS: CollectionsData = {
  titleLead: 'Payment',
  titleAccent: 'links',
  subtitle: 'Make a link, send it to the patient, see whether the money arrived.',
  waitingCount: 3,
  notYetPaid: 1240,
  collected30d: 8420,
  period: '30d',
  accountConnected: true,
  rows: ROWS,
  drawerPatient: {
    id: 'p-1044', name: 'Karen Brennan', initials: 'KB',
    chartLine: 'Chart 10482 · last visit 12 Sep',
    balance: 1850,
    balanceProvenance: 'Patient portion after insurance. Read from Ascend 6 minutes ago.',
    contacts: {
      text: [
        { id: 'c1', value: '(415) 555‑0148', meta: 'Mobile · 6 texts delivered, none failed' },
        { id: 'c2', value: '(415) 555‑7781', meta: 'Home · a landline, a text will not arrive', disabled: true },
      ],
      email: [{ id: 'c3', value: 'k.brennan@gmail.com', meta: 'Personal · 12 emails delivered' }],
    },
    arSequencingNote:
      'Karen is in Older balances. Sending your own link pauses it for her — the follow-up won’t message her again until you resume it from her row.',
  },
};
